module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Notification settings","subtitle":"Configure how you want to receive system notifications.","emailLabel":"Receive notifications by email","howItWorks":"How it works","howItWorksText":"When enabled, important events and updates will be duplicated to your email. You can change this setting anytime."}}')
  delete Component.options._Ctor
}
